import { RowClassParams } from "ag-grid-community";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useAuth } from "src/app/utils/useAuth";
import { SimpleEntityGrid } from "../../../components/grid/SimpleEntityGrid";
import {
    AddWritersToOrderContainer,
    AIGuideFormContainer,
    SendTextOrderFormContainer,
    UpsertOrderFormContainer,
} from "../../../containers";
import { OrderTransport } from "../../../transports/order";
import { Order, UpsertOrderDTOSchema } from "../../../types/orders/order";
import useWriteGridActions from "./useWriteGridActions";
import useWriteGridColumns from "./useWriteGridColumns";
import { PageTitle } from "src/_metronic/layout/core";
import {
    getLangValuesAsync,
    getManagerValuesAsync,
    getMoneySiteValuesAsync,
    getRdValuesAsync,
    getThematicValuesAsync,
    getWriterValuesAsync,
    getWritingTypeValuesAsync,
} from "./WriteHelps";
import useStockGridToolbarButtons from "../StockGrid/useStockGridToolbarButtons";

const WriteGrid: React.FC = () => {
    const { formatMessage } = useIntl();
    const { currentUser } = useAuth();

    const [selectedRows, setSelectedRows] = useState<Array<Order>>([]);
    const [orderToUpdateGrid, setValueToUpdateGrid] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const handleAddWriterAction = (obj: any) => {
        setSelectedRows(obj.selectedRows);
        setShowModal(true);
    };
    const toolActionsButton = useStockGridToolbarButtons(currentUser.role, handleAddWriterAction);
    const handlerValueToUpdateGrid = (update: boolean) => {
        setValueToUpdateGrid(update);
    };
    const handleClose = () => {
        setShowModal(false);
    };
    const gridColumns = useWriteGridColumns(
        getManagerValuesAsync,
        getWriterValuesAsync,
        getMoneySiteValuesAsync,
        getRdValuesAsync,
        getWritingTypeValuesAsync,
        getThematicValuesAsync,
        getLangValuesAsync
    );
    const { actions, AIGuideCondition } = useWriteGridActions(currentUser);

    const rowStyle = (params: RowClassParams) => {
        if (params.node?.data?.returnCount === 1) return { background: "#ff7675" };
    };

    return (
        <>
            <PageTitle>{formatMessage({ id: "write.title" })}</PageTitle>
            <SimpleEntityGrid
                getRowStyle={rowStyle}
                columns={gridColumns}
                orderToUpdateGrid={orderToUpdateGrid}
                rowModelType="serverSide"
                modalProps={{ size: "xl" }}
                actions={actions}
                actionsConditions={{
                    AIGuide: AIGuideCondition,
                }}
                sendTextFormBodyContainer={SendTextOrderFormContainer}
                toolbarButtonAction={toolActionsButton}
                saveHandler={OrderTransport.save}
                entityName={formatMessage({ id: "common.entity.write" })}
                validationSchema={UpsertOrderDTOSchema}
                AIGuideFormBodyContainer={AIGuideFormContainer}
                listHandler={OrderTransport.write.list}
                exportHandler={OrderTransport.write.export}
                totalRowsHandle={OrderTransport.write.findTotal}
                totalFilteredHandle={OrderTransport.write.findTotalFiltered}
                toggleActiveHandler={OrderTransport.toggleActive}
                formTransformer={OrderTransport.formTransformer}
                formBody={UpsertOrderFormContainer}
            />
            <AddWritersToOrderContainer
                selectedRows={selectedRows}
                handlerValueToUpdateGrid={handlerValueToUpdateGrid}
                handleClose={handleClose}
                showModal={showModal}
            />
        </>
    );
};

export default WriteGrid;
